import React from 'react';

const OpenAILogo = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
    <path d="M22.282 9.821a5.985 5.985 0 0 0-.516-4.91 6.046 6.046 0 0 0-6.51-2.9A6.065 6.065 0 0 0 4.981 4.18a5.985 5.985 0 0 0-3.998 2.9 6.046 6.046 0 0 0 .743 7.097 5.98 5.98 0 0 0 .51 4.911 6.051 6.051 0 0 0 6.515 2.9A5.985 5.985 0 0 0 13.26 24a6.056 6.056 0 0 0 5.772-4.206 5.99 5.99 0 0 0 3.997-2.9 6.056 6.056 0 0 0-.747-7.073zM13.26 22.43a4.476 4.476 0 0 1-2.876-1.04l.141-.081 4.779-2.758a.795.795 0 0 0 .392-.681v-6.737l2.02 1.168a.071.071 0 0 1 .038.052v5.583a4.504 4.504 0 0 1-4.494 4.494zM3.6 18.304a4.47 4.47 0 0 1-.535-3.014l.142.085 4.783 2.759a.771.771 0 0 0 .78 0l5.843-3.369v2.332a.08.08 0 0 1-.033.062L9.74 19.95a4.5 4.5 0 0 1-6.14-1.646zM2.34 7.896a4.485 4.485 0 0 1 2.366-1.973V11.6a.766.766 0 0 0 .388.676l5.815 3.355-2.02 1.168a.076.076 0 0 1-.071 0l-4.83-2.786A4.504 4.504 0 0 1 2.34 7.872zm16.597 3.855l-5.833-3.387L15.119 7.2a.076.076 0 0 1 .071 0l4.83 2.791a4.494 4.494 0 0 1-.676 8.105v-5.678a.79.79 0 0 0-.407-.667zm2.01-3.023l-.141-.085-4.774-2.782a.776.776 0 0 0-.785 0L9.409 9.23V6.897a.066.066 0 0 1 .028-.061l4.83-2.787a4.5 4.5 0 0 1 6.68 4.66zm-12.64 4.135l-2.02-1.164a.08.08 0 0 1-.038-.057V6.075a4.5 4.5 0 0 1 7.375-3.453l-.142.08L8.704 5.46a.795.795 0 0 0-.393.681zm1.097-2.365l2.602-1.5 2.607 1.5v2.999l-2.597 1.5-2.607-1.5z" />
  </svg>
);

const AnthropicLogo = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
    <path d="M13.827 3.52h3.603L24 20.48h-3.603l-6.57-16.96zm-7.258 0h3.767L16.906 20.48h-3.674l-1.343-3.461H5.017l-1.344 3.46H0L6.57 3.522zm1.24 4.8L5.17 14.18h5.276L7.808 8.32z" />
  </svg>
);

const GeminiLogo = () => (
  <svg viewBox="0 0 28 28" fill="none" className="w-6 h-6">
    <path d="M14 28C14 21.373 8.627 16 2 16C8.627 16 14 10.627 14 4C14 10.627 19.373 16 26 16C19.373 16 14 21.373 14 28Z" fill="url(#gemini-grad)" />
    <defs>
      <linearGradient id="gemini-grad" x1="2" y1="4" x2="26" y2="28" gradientUnits="userSpaceOnUse">
        <stop stopColor="#4285F4" />
        <stop offset="0.5" stopColor="#9B72CB" />
        <stop offset="1" stopColor="#D96570" />
      </linearGradient>
    </defs>
  </svg>
);

const MistralLogo = () => (
  <svg viewBox="0 0 28 24" fill="none" className="w-7 h-6">
    <rect x="0" y="0" width="5" height="5" fill="#F7D046" />
    <rect x="11.5" y="0" width="5" height="5" fill="#F7D046" />
    <rect x="23" y="0" width="5" height="5" fill="#F7D046" />
    <rect x="0" y="6.5" width="5" height="5" fill="#F2A73B" />
    <rect x="5.75" y="6.5" width="5" height="5" fill="#F2A73B" />
    <rect x="11.5" y="6.5" width="5" height="5" fill="#F2A73B" />
    <rect x="17.25" y="6.5" width="5" height="5" fill="#F2A73B" />
    <rect x="23" y="6.5" width="5" height="5" fill="#F2A73B" />
    <rect x="0" y="13" width="5" height="5" fill="#EE792F" />
    <rect x="11.5" y="13" width="5" height="5" fill="#EE792F" />
    <rect x="23" y="13" width="5" height="5" fill="#EE792F" />
    <rect x="0" y="19" width="5" height="5" fill="#EB5829" />
    <rect x="5.75" y="19" width="5" height="5" fill="#EB5829" />
    <rect x="11.5" y="19" width="5" height="5" fill="#EB5829" />
    <rect x="17.25" y="19" width="5" height="5" fill="#EB5829" />
    <rect x="23" y="19" width="5" height="5" fill="#EB5829" />
  </svg>
);

const AzureLogo = () => (
  <svg viewBox="0 0 96 96" className="w-7 h-7">
    <path d="M33.338 6.544h26.038l-27.03 80.455a4.152 4.152 0 0 1-3.933 2.824H8.149a4.145 4.145 0 0 1-3.928-5.47L29.404 9.368a4.152 4.152 0 0 1 3.934-2.825z" fill="#0078D4" />
    <path d="M71.175 60.261H41.296a1.911 1.911 0 0 0-1.305 3.309l26.532 24.764a4.171 4.171 0 0 0 2.846 1.121h23.586z" fill="#0078D4" />
    <path d="M33.338 6.544a4.118 4.118 0 0 0-3.943 2.879L4.252 84.09a4.142 4.142 0 0 0 3.908 5.534h20.787a4.443 4.443 0 0 0 3.41-2.9l5.014-14.777 17.91 16.705a4.237 4.237 0 0 0 2.666.972h23.623L62.127 6.544z" fill="url(#azure-grad)" />
    <defs>
      <linearGradient id="azure-grad" x1="45" y1="6" x2="45" y2="90" gradientUnits="userSpaceOnUse">
        <stop stopColor="#1988D9" />
        <stop offset="1" stopColor="#0078D4" />
      </linearGradient>
    </defs>
  </svg>
);

const AWSLogo = () => (
  <svg viewBox="0 0 80 48" className="w-9 h-5">
    <path d="M22.8 21.7c0 .9.1 1.6.3 2.2.2.5.5 1.1.9 1.7.1.2.2.4.2.5 0 .2-.1.4-.4.6l-1.2.8c-.2.1-.3.2-.5.2-.2 0-.4-.1-.6-.3-.3-.3-.5-.6-.7-1-.2-.3-.4-.7-.6-1.1-1.6 1.9-3.6 2.8-6 2.8-1.7 0-3.1-.5-4.1-1.5s-1.5-2.3-1.5-3.9c0-1.7.6-3.1 1.9-4.2 1.3-1 2.9-1.6 5-1.6.7 0 1.4.1 2.2.2.8.1 1.5.3 2.4.5v-1.5c0-1.5-.3-2.6-1-3.3-.6-.7-1.7-1-3.3-1-.7 0-1.5.1-2.2.3-.8.2-1.5.5-2.2.8-.3.2-.6.3-.7.3-.2 0-.3-.2-.3-.5V11c0-.3 0-.5.1-.6.1-.1.2-.3.5-.4.7-.4 1.6-.7 2.6-.9 1-.3 2-.4 3.1-.4 2.4 0 4.1.5 5.2 1.6 1.1 1.1 1.6 2.7 1.6 4.9v6.4zm-8.3 3.1c.7 0 1.4-.1 2.1-.4.8-.3 1.4-.7 1.9-1.3.3-.4.5-.8.6-1.3.1-.5.2-1.1.2-1.8v-.9c-.6-.2-1.2-.3-1.9-.4-.7-.1-1.3-.1-2-.1-1.4 0-2.3.3-3 .8-.7.5-1 1.3-1 2.3 0 .9.2 1.6.7 2.1.5.6 1.3.9 2.4.9zm16.5 2.2c-.3 0-.4 0-.6-.1-.1-.1-.3-.3-.4-.6L24.7 11c-.1-.3-.2-.5-.2-.7 0-.3.1-.4.4-.4h1.8c.3 0 .5 0 .6.1.1.1.3.3.3.6l4.2 16.5 3.9-16.5c.1-.3.2-.5.3-.6.1-.1.4-.1.6-.1h1.5c.3 0 .5 0 .6.1.1.1.3.3.3.6l3.9 16.7L47.3 11c.1-.3.2-.5.3-.6.2-.1.4-.1.6-.1h1.7c.3 0 .4.1.4.4 0 .1 0 .2-.1.3 0 .1-.1.3-.1.4l-5.6 15.3c-.1.3-.2.5-.4.6-.1.1-.4.1-.6.1h-1.6c-.3 0-.5 0-.6-.1-.1-.1-.3-.3-.3-.6l-3.8-16.1-3.8 16.1c-.1.3-.2.5-.3.6-.1.1-.4.2-.6.2h-1.6zm26.4.6c-1.1 0-2.1-.1-3.1-.4-1-.3-1.8-.6-2.3-1-.3-.2-.5-.4-.6-.6 0-.1-.1-.3-.1-.4v-.8c0-.4.1-.5.4-.5.1 0 .2 0 .3.1.1.1.3.1.5.3.7.3 1.4.6 2.2.8.8.2 1.6.3 2.3.3 1.2 0 2.2-.2 2.8-.7.7-.5 1-1.1 1-1.9 0-.6-.2-1-.5-1.4-.4-.4-1-.7-1.9-1l-2.7-.8c-1.4-.4-2.4-1.1-3-1.9-.6-.8-.9-1.7-.9-2.7 0-.8.2-1.5.5-2.1.3-.6.8-1.1 1.3-1.5.6-.4 1.2-.8 2-1 .8-.2 1.5-.3 2.4-.3.4 0 .9 0 1.3.1.5.1.9.2 1.3.3.4.1.8.3 1.1.4.3.2.6.3.8.5.2.1.3.3.4.5.1.2.1.3.1.5v.7c0 .3-.1.5-.4.5-.1 0-.4-.1-.6-.3-1-.5-2.1-.7-3.4-.7-1.1 0-2 .2-2.6.6-.6.4-.9 1-.9 1.9 0 .6.2 1 .6 1.4.4.4 1.1.7 2 1l2.7.8c1.4.4 2.3 1 3 1.8.6.8.9 1.6.9 2.6 0 .8-.2 1.5-.5 2.2-.3.6-.8 1.2-1.4 1.6-.6.5-1.3.8-2.1 1-.9.3-1.8.4-2.7.4z" fill="#252F3E" />
    <path d="M55.3 37.1c-6.5 4.8-15.9 7.3-24 7.3-11.4 0-21.6-4.2-29.3-11.2-.6-.6-.1-1.3.7-.9 8.3 4.9 18.7 7.8 29.3 7.8 7.2 0 15.1-1.5 22.3-4.6 1.1-.5 2 .7.9 1.5z" fill="#FF9900" />
    <path d="M58 33.9c-.8-1.1-5.6-.5-7.7-.3-.6.1-.7-.5-.2-.9 3.8-2.6 10-1.9 10.7-1 .7.9-.2 7.2-3.7 10.2-.5.5-1.1.2-.8-.3.8-1.9 2.6-6.6 1.8-7.7z" fill="#FF9900" />
  </svg>
);

const GCPLogo = () => (
  <svg viewBox="0 0 256 206" className="w-8 h-6">
    <path d="M170.252 56.819l22.253-22.253 1.483-9.37C153.437-11.677 88.976-7.496 52.42 33.92 42.267 45.834 34.39 59.656 29.167 74.611L37.455 73.5l44.507-7.34s2.271-3.776 3.427-3.563c16.38-18.07 40.927-26.156 64.862-19.778z" fill="#EA4335" />
    <path d="M224.205 73.918a100.249 100.249 0 0 0-30.217-48.722l-31.232 31.232a55.515 55.515 0 0 1 20.379 44.037v5.544c15.351 0 27.8 12.449 27.8 27.8 0 15.352-12.449 27.482-27.8 27.482h-55.601l-5.527 5.862v33.275l5.527 5.544h55.601c39.748.318 72.376-31.494 72.693-71.242a72.088 72.088 0 0 0-31.623-60.812z" fill="#4285F4" />
    <path d="M72.008 205.972h55.6v-44.506h-55.6a27.377 27.377 0 0 1-11.399-2.49l-7.886 2.415-22.253 22.253-1.949 7.572C41.707 199.758 56.502 206.12 72.008 205.972z" fill="#34A853" />
    <path d="M72.008 61.428C32.26 61.746-.052 94.692.266 134.44a72.076 72.076 0 0 0 28.255 56.774l32.088-32.088c-13.353-6.036-19.291-21.7-13.255-35.053s21.7-19.291 35.053-13.255a27.8 27.8 0 0 1 13.255 13.255l32.088-32.088A72.013 72.013 0 0 0 72.008 61.428z" fill="#FBBC05" />
  </svg>
);

const HarmonicMark = () => (
  <svg viewBox="0 0 24 24" fill="none" className="w-6 h-6 shrink-0">
    <path d="M3 13a9 9 0 0 1 18 0" stroke="#6C2BD9" strokeWidth="2" strokeLinecap="round" />
    <path d="M6.5 13a5.5 5.5 0 0 1 11 0" stroke="#6C2BD9" strokeWidth="2" strokeLinecap="round" />
    <circle cx="12" cy="13" r="1.75" fill="#6C2BD9" />
  </svg>
);

export { OpenAILogo, AnthropicLogo, GeminiLogo, MistralLogo, AzureLogo, AWSLogo, GCPLogo, HarmonicMark };

export const EcosystemSection = () => {
  return (
    <section id="sovereignty" className="bg-[#FBFBFB] py-14 px-4 sm:px-6 lg:px-8 scroll-mt-20">
      <div className="max-w-[1720px] mx-auto">
        <div className="bg-white border border-slate-200 rounded-2xl px-8 md:px-14 py-7 md:py-8">
          <div className="grid lg:grid-cols-[1.5fr_1fr_1fr_1fr] gap-8 lg:gap-16 items-start">
            {/* Left description */}
            <div className="lg:col-span-1">
              <span className="inline-block text-[9px] font-bold uppercase tracking-[0.15em] text-[#F58220] border border-[#F58220]/30 rounded px-2.5 py-1 mb-4 font-mono">
                THE APEX DEAL LAYER
              </span>
              <h3 className="text-2xl md:text-3xl font-black text-[#0F172A] leading-tight mb-4">
                Open Ecosystem.<br />
                Sovereign Perimeter.
              </h3>
              <p className="text-sm text-slate-500 leading-relaxed">
                Your cloud. Your models. Your proprietary deal playbooks. Unified by Frontier into a cognitive thesis underwriting engine.
              </p>
            </div>

            {/* Reasoning Models */}
            <div>
              <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-400 mb-5 font-mono whitespace-nowrap">
                MODEL AGNOSTIC
              </p>
              <div className="flex flex-col gap-3.5">
                <div className="flex items-center gap-3 h-8">
                  <div className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center text-slate-700 shrink-0">
                    <OpenAILogo />
                  </div>
                  <span className="text-[12px] text-slate-600 font-medium">OpenAI</span>
                </div>
                <div className="flex items-center gap-3 h-8">
                  <div className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center text-slate-700 shrink-0">
                    <AnthropicLogo />
                  </div>
                  <span className="text-[12px] text-slate-600 font-medium">Anthropic</span>
                </div>
                <div className="flex items-center gap-3 h-8">
                  <div className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center shrink-0">
                    <GeminiLogo />
                  </div>
                  <span className="text-[12px] text-slate-600 font-medium">Gemini</span>
                </div>
                <div className="flex items-center gap-3 h-8">
                  <div className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center shrink-0">
                    <MistralLogo />
                  </div>
                  <span className="text-[12px] text-slate-600 font-medium">Mistral</span>
                </div>
              </div>
            </div>

            {/* Sovereign Clouds */}
            <div>
              <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-400 mb-5 font-mono whitespace-nowrap">
                CLOUD AGNOSTIC
              </p>
              <div className="flex flex-col gap-3.5">
                <div className="flex items-center gap-3 h-8">
                  <div className="w-9 flex items-center justify-center shrink-0"><AzureLogo /></div>
                  <span className="text-[12px] text-slate-600 font-medium">Microsoft Azure</span>
                </div>
                <div className="flex items-center gap-3 h-8">
                  <div className="w-9 flex items-center justify-center shrink-0"><AWSLogo /></div>
                  <span className="text-[12px] text-slate-600 font-medium">Amazon Web Services</span>
                </div>
                <div className="flex items-center gap-3 h-8">
                  <div className="w-9 flex items-center justify-center shrink-0"><GCPLogo /></div>
                  <span className="text-[12px] text-slate-600 font-medium">Google Cloud</span>
                </div>
                <div className="flex items-center gap-3 h-8">
                  <div className="w-9 flex items-center justify-center shrink-0">
                    <span className="font-mono font-black text-sm text-[#F58220]">C42</span>
                  </div>
                  <span className="text-[12px] text-slate-600 font-medium">Core42</span>
                </div>
              </div>
            </div>

            {/* Market Data & VDRs */}
            <div>
              <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-400 mb-5 font-mono whitespace-nowrap">
                UNIFYING TOOL SPRAWL
              </p>
              <div className="flex flex-col gap-3.5">
                <div className="flex items-center gap-3 h-8">
                  <div className="w-9 flex items-center justify-center shrink-0"><img src="/logos/pitchbook-mark.png" alt="" className="h-5 w-auto object-contain" /></div>
                  <span className="text-[12px] text-slate-600 font-medium">PitchBook</span>
                </div>
                <div className="flex items-center gap-3 h-8">
                  <div className="w-9 flex items-center justify-center shrink-0"><HarmonicMark /></div>
                  <span className="text-[12px] text-slate-600 font-medium">Harmonic</span>
                </div>
                <div className="flex items-center gap-3 h-8">
                  <div className="w-9 flex items-center justify-center shrink-0"><img src="/logos/datasite-mark.png" alt="" className="h-5 w-auto object-contain" /></div>
                  <span className="text-[12px] text-slate-600 font-medium">Datasite</span>
                </div>
                <div className="flex items-center gap-3 h-8">
                  <div className="w-9 flex items-center justify-center shrink-0"><img src="/logos/affinity-mark.png" alt="" className="h-[22px] w-auto object-contain" /></div>
                  <span className="text-[12px] text-slate-600 font-medium">Affinity</span>
                </div>
                <span className="text-[10px] text-slate-400 font-medium pl-1 pt-1">+ many more</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
